import { useContext, useMemo } from 'react';
import { PaywallAddons } from './paywall-addons';
import { PaywallBookDemo } from './paywall-book-demo';
import { PaywallContext } from './paywall-context';
import { PaywallContinueWithFree } from './paywall-continue-with-free';
import { PaywallFreeTrial } from './paywall-free-trial';
import { mapReasonToAddon } from './util';

export const PaywallFooter = () => {
  const { mode, isFreePlan, reason, isAppsumo, showFreeTrial } = useContext(PaywallContext);

  const footer = useMemo(() => {
    if (isAppsumo) {
      return null;
    }
    if (mode === 'trialStart') {
      if (!showFreeTrial) {
        return <PaywallBookDemo />;
      } else {
        return (
          <>
            <PaywallBookDemo />
            <PaywallFreeTrial />
          </>
        );
      }
    }
    if (mode === 'trialEnd') {
      return (
        <>
          <PaywallBookDemo />
          <PaywallContinueWithFree />
        </>
      );
    }
    if (mode === 'upgrade') {
      if (!isFreePlan) {
        return <PaywallAddons isOpen={!!mapReasonToAddon(reason)} />;
      } else {
        return <PaywallBookDemo />;
      }
    }

    return null;
  }, [isAppsumo, mode, isFreePlan, reason, showFreeTrial]);

  return <div className="paywall__footer mt-9">{footer}</div>;
};
